import { createStore } from 'vuex';

// Store
import pages from '@/modules/pages';
let $content = [
  {
    body: () => import('../content/tecnologias.html'),
    path: '/tecnologias',
    title: 'Tecnologías',
    keywords:
      'Tecnologías de Información, Arquitectura de Software, Stack Tecnológico, Cloud, DevOps, Ciberseguridad, Integraciones, APIs, Microservicios, Contenedores, Observabilidad, Tecnologías \
    Modernas, Desarrollo Full-Stack, Herramientas Digitales, Innovación Tecnológica, Soluciones Escalables, Python, JavaScript, VueJS, PHP, Integración API',
    description: 'Descubre cómo Ing. Obed Javier utiliza tecnologías modernas para crear soluciones escalables que impulsan el crecimiento de tu empresa y optimizan procesos',
    images: [require('@/assets/img/tecnologias.jpg')],
  },
  {
    body: () => import('../content/tecnologias/bases-de-datos.html'),
    path: '/bases-de-datos',
    title: 'Bases de Datos',
    keywords: 'Bases de Datos, Gestión de Información, Data Analytics, Almacenamiento Seguro, Optimización de Datos, SQL, NoSQL, Gobernanza de Datos, Inteligencia de Negocio',
    description: 'Optimiza la gestión de tus datos. Ing. Obed Javier diseña y administra bases de datos robustas para decisiones inteligentes y operaciones fluidas en tu empresa.',
    images: [require('@/assets/img/database.jpg'), require('@/assets/img/mysql.png')],
  },
  {
    body: () => import('../content/tecnologias/desarrollo.html'),
    path: '/desarrollo',
    title: 'Desarrollo',
    keywords: 'Desarrollo de Software, Sistemas a Medida, Soluciones Digitales, Ingeniería de Software, Automatización Empresarial, Productividad IT, Eficiencia Operativa, Proyectos IT',
    description: 'Necesitas soluciones a medida? Ing. Obed Javier lidera el desarrollo de software y sistemas que resuelven desafíos complejos y optimizan operaciones empresariales.',
    images: [require('@/assets/img/analisis.jpg'), require('@/assets/img/agile-development.png'), require('@/assets/img/git-workflow.png'), require('@/assets/img/benefits-php.png')],
  },
  {
    body: () => import('../content/tecnologias/plataformas.html'),
    path: '/plataformas',
    title: 'Plataformas Tecnológicas',
    keywords: 'Plataformas Empresariales, Implementación de Software, Sistemas Integrados, Gestión de Plataformas, Transformación Digital, Soluciones Cloud, Tecnología Empresarial',
    description: 'Transforma tu negocio con las plataformas adecuadas. Ing. Obed Javier te asesora en la selección e implementación de plataformas robustas que impulsan tu crecimiento y eficiencia.',
    images: [require('@/assets/img/plataformas.jpg')],
  },
  {
    body: () => import('../content/tecnologias/servidores.html'),
    path: '/servidores',
    title: 'Servidores',
    keywords:
      'Administración de Servidores, Infraestructura TI, Servidores Cloud, Servidores Dedicados, Mantenimiento de Servidores, Seguridad de Servidores, Optimización de Rendimiento, Alta Disponibilidad\
      , Continuidad de Negocio.',
    description:
      'Garantiza la continuidad de tu negocio con una gestión de servidores experta. Ing. Obed Javier optimiza y asegura tu infraestructura para un rendimiento máximo y una seguridad robusta.',
    images: [require('@/assets/img/servidor.jpg')],
  },
  {
    body: () => import('../content/productos.html'),
    path: '/productos',
    title: 'Productos',
    keywords: 'Desarrollo de Productos Digitales, Gestión de Productos, Estrategia de Producto, Innovación de Software, Lanzamiento de Productos, MVP, Liderazgo Tecnológico',
    description: 'Necesitas un producto digital exitoso? Ing. Obed Javier lidera el desarrollo y lanzamiento de productos tecnológicos que capturan valor y generan impacto en el mercado.',
    images: [require('@/assets/img/products.jpg')],
  },
  {
    body: () => import('../content/productos/big-data.html'),
    path: '/big-data',
    title: 'Big Data',
    keywords: 'Big Data, Análisis de Datos, Ciencia de Datos, Inteligencia Artificial, Machine Learning, Predicción de Negocio, Optimización de Decisiones, Estrategia de Datos',
    description: 'Desbloquea el poder de tus datos masivos. Ing. Obed Javier te ayuda a transformar Big Data en insights accionables para decisiones estratégicas y ventaja competitiva.',
    images: [require('@/assets/img/8vs-big-data.jpg')],
  },
  {
    body: () => import('../content/productos/cms.html'),
    path: '/cms-sistema-de-administracion-de-contenido',
    title: 'CMS (Sistema de Administración de Contenido)',
    keywords: 'CMS, Sistema de Contenido, WordPress, Drupal, Joomla, Contenido Web, Gestión Digital, Experiencia de Usuario, Marketing de Contenidos',
    description: 'Gestiona tu contenido digital eficientemente. Ing. Obed Javier implementa sistemas CMS que optimizan tu presencia online y la experiencia de tus usuarios.',
    images: [require('@/assets/img/sitios-web.jpg'), require('@/assets/img/CMS.jpg')],
  },
  {
    body: () => import('../content/productos/crm.html'),
    path: '/crm-sistema-de-administracion-de-relaciones-con-clientes',
    title: 'CRM (Sistema de Administración de Relaciones con Clientes)',
    keywords: 'CRM, Gestión de Clientes, Ventas, Marketing, Servicio al Cliente, Automatización de Ventas, Retención de Clientes, Estrategia Comercial',
    description: 'Potencia tus relaciones con clientes. Ing. Obed Javier implementa sistemas CRM que mejoran tus ventas, servicio y fidelización, impulsando el crecimiento de tu negocio.',
    images: [require('@/assets/img/crm-2.png'), require('@/assets/img/CRM-1.png'), require('@/assets/img/CRM-2.png')],
  },
  {
    body: () => import('../content/productos/e-commerce.html'),
    path: '/e-commerce-sistema-de-comercio-electronico',
    title: 'e-Commerce (Sistema de Comercio Electrónico)',
    keywords: 'E-commerce, Tienda Online, Comercio Electrónico, OpenCart, Magento, WooCommerce, Ventas Online, Estrategia Digital, Pasarelas de Pago',
    description: 'Lanza o escala tu tienda online. Ing. Obed Javier desarrolla soluciones e-commerce robustas que maximizan tus ventas y ofrecen una experiencia de compra superior.',
    images: [require('@/assets/img/ecommerce_0.jpg'), require('@/assets/img/ecommerce.jpg')],
  },
  {
    body: () => import('../content/productos/erp.html'),
    path: '/erp-sistema-de-administracion-de-recursos-empresariales',
    title: 'ERP (Sistema de Administración de Recursos Empresariales)',
    keywords:
      'ERP, Planificación de Recursos Empresariales, Odoo, Dolibarr, ERPNext, Adempiere, ERP a Medida, Optimización de Procesos, Eficiencia Operativa, Integración de Sistemas, Gestión de la Cadena de\
      Suministro.',
    description:
      'Integra y optimiza todas las áreas de tu negocio. Ing. Obed Javier implementa sistemas ERP para unificar finanzas, operaciones y recursos humanos, dándote una visibilidad total y mejorando la \
      toma de decisiones.',
    images: [require('@/assets/img/erp.png')],
  },
  {
    body: () => import('../content/productos/lcms.html'),
    path: '/lcms-sistema-de-gestion-de-contenido-para-el-aprendizaje',
    title: 'LCMS (Sistema de Gestión de Contenido para el Aprendizaje)',
    keywords: 'LCMS, LMS, E-learning, Gestión del Aprendizaje, Moodle, Plataformas Educativas, Capacitación Corporativa, Contenido Formativo, Aprendizaje Online, SCORM.',
    description:
      'Transforma la capacitación y el aprendizaje en tu organización. Ing. Obed Javier implementa plataformas LCMS/LMS para crear, gestionar y distribuir contenido formativo de alto impacto.',
    images: [require('@/assets/img/LCMS.jpeg'), require('@/assets/img/lcms.jpg')],
  },
  {
    body: () => import('../content/servicios.html'),
    path: '/servicios',
    title: 'Servicios',
    keywords:
      'Servicios de innovación TI, Consultoría Tecnológica, Transformación Digital, Desarrollo de Software, Arquitectura de Sistemas, Estrategia Digital, Soluciones Cloud, Ciberseguridad, Gestión de \
      Proyectos TI, Innovación Empresarial.',
    description:
      'Descubre un portafolio de servicios tecnológicos diseñados para resolver desafíos de negocio. Ing. Obed Javier ofrece desde consultoría estratégica hasta el desarrollo e implementación de \
      soluciones a medida.',
    images: [require('@/assets/img/services.jpg')],
  },
  {
    body: () => import('../content/servicios/arquitectura.html'),
    path: '/arquitectura-sistemas',
    title: 'Arquitectura de Sistemas',
    keywords:
      'Arquitecto de Sistemas, Arquitectura de Software, Diseño de Soluciones TI, Soluciones Escalables, Arquitectura Cloud, Microservicios, Seguridad por Diseño, Hoja de Ruta Tecnológica, Deuda \
      Técnica, Alineación de Negocio y TI, Liderazgo Técnico',
    description:
      'Diseño y construyo la base tecnológica para el crecimiento de tu negocio. Ing. Obed Javier aplica las mejores prácticas para garantizar el éxito de tus proyectos, creando soluciones robustas, \
      escalables y seguras que alinean la tecnología con tus objetivos estratégicos.',
    images: [require('@/assets/img/arquitectura.png')],
  },
  {
    body: () => import('../content/servicios/cloud.html'),
    path: '/centro-de-datos-hosting-cloud',
    title: 'Centro de Datos / Hosting / Cloud',
    keywords: 'Centro de Datos, Hosting, Cloud Computing, Alojamiento Web, AWS, Google Cloud, Azure, Oracle, Alibaba, Infraestructura Cloud, Migración a la Nube, Servidores Virtuales, IaaS, PaaS.',
    description:
      'Elige la infraestructura de alojamiento ideal para tu negocio. Ing. Obed Javier te asesora en soluciones de centro de datos, hosting y cloud para garantizar rendimiento, escalabilidad y \
      seguridad.',
    images: [require('@/assets/img/datacenter.jpg')],
  },
  {
    body: () => import('../content/servicios/community-manager.html'),
    path: '/community-manager-gestion-de-la-comunidad-online',
    title: 'Community Manager (Gestión de la Comunidad Online)',
    keywords: 'Community Manager, Gestión de Redes Sociales, Estrategia de Social Media, Marketing de Contenidos, Interacción con Audiencia, Reputación Online, SMO, SMM, Crecimiento de Comunidad.',
    description:
      'Construye una comunidad online activa y leal alrededor de tu marca. Como Community Manager, Ing. Obed Javier gestiona tus redes sociales para aumentar el engagement, la visibilidad y la \
      reputación de tu negocio.',
    images: [require('@/assets/img/community-manager.jpg')],
  },
  {
    body: () => import('../content/servicios/email.html'),
    path: '/correo-electronico',
    title: 'Correo Electrónico',
    keywords: 'Correo Electrónico Corporativo, Email Profesional, G Suite, Office 365, Servidores de Correo, Email Marketing, Seguridad de Email, Migración de Correo, Email Transaccional.',
    description:
      'Profesionaliza la comunicación de tu empresa con un servicio de correo electrónico seguro y confiable. Ing. Obed Javier configura y gestiona soluciones de email corporativo y marketing.',
    images: [require('@/assets/img/email.jpg')],
  },
  {
    body: () => import('../content/servicios/desarrollo-web.html'),
    path: '/desarrollo-web',
    title: 'Desarrollo Web',
    keywords:
      'Desarrollo Web, Diseño Web, Creación de Sitios Web, Desarrollo Front-End, Desarrollo Back-End, Sitios Web Corporativos, Landing Pages, Optimización de Velocidad Web (WPO), Experiencia de \
      Usuario (UX).',
    description:
      'Transforma tu presencia online con un sitio web profesional y de alto rendimiento. Ing. Obed Javier desarrolla soluciones web a medida, centradas en la experiencia de usuario y los objetivos \
      de negocio.',
    images: [require('@/assets/img/web-development.jpg')],
  },
  {
    body: () => import('../content/servicios/desarrollo-de-sistemas.html'),
    path: '/desarrollo-de-sistemas',
    title: 'Desarrollo de Software',
    keywords:
      'Desarrollo de Sistemas, Software a Medida, Aplicaciones Empresariales, Automatización de Procesos, Integración de API, Arquitectura de Software, Sistemas Legacy, Transformación de \
      Aplicaciones.',
    description:
      'Resuelve desafíos de negocio únicos con software hecho a tu medida. Ing. Obed Javier lidera el desarrollo de sistemas que automatizan procesos, integran plataformas y optimizan la eficiencia \
      operativa.',
    images: [require('@/assets/img/software-development.jpg')],
  },
  {
    body: () => import('../content/servicios/e-marketing.html'),
    path: '/e-marketing-mercadotecnia-online',
    title: 'e-Marketing (Mercadotecnia Online)',
    keywords: 'Marketing Digital, E-marketing, Estrategia Digital, SEO, SEM, Marketing de Contenidos, Inbound Marketing, Generación de Leads, Analítica Web, ROI Digital.',
    description:
      'Atrae, convierte y fideliza clientes en el entorno digital. Ing. Obed Javier diseña y ejecuta estrategias de e-marketing integrales, enfocadas en generar resultados de negocio medibles.',
    images: [require('@/assets/img/emarketing.jpeg')],
  },
  {
    body: () => import('../content/servicios/email-marketing.html'),
    path: '/email-marketing-mercadotecnia-en-correos-electronicos',
    title: 'Email Marketing (Mercadotecnia en Correos Electrónicos)',
    keywords: 'Email Marketing, Campañas de Email, Automatización de Marketing, Newsletters, Lead Nurturing, Segmentación de Audiencia, Mailchimp, Pruebas A/B, Tasa de Apertura.',
    description:
      'Comunícate directamente con tu audiencia y fomenta la lealtad. Ing. Obed Javier gestiona campañas de email marketing que nutren leads, informan a tus clientes y generan ventas recurrentes.',
    images: [require('@/assets/img/email-marketing.jpg')],
  },
  {
    body: () => import('../content/servicios/idi.html'),
    path: '/investigacion-desarrollo-e-innovacion-de-nuevas-tecnologias',
    title: 'Investigación, Desarrollo e Innovación de Nuevas Tecnologías',
    keywords:
      'I+D, I+D+i, Innovación Tecnológica, Investigación y Desarrollo, Nuevas Tecnologías, Transformación Digital, Prototipado, Pruebas de Concepto (PoC), Vigilancia Tecnológica, Lean Startup, \
      Design Thinking.',
    description:
      'Convierte la innovación en una ventaja competitiva sostenible. Ing. Obed Javier lidera proyectos de I+D+i para explorar, validar e implementar nuevas tecnologías que abran oportunidades de \
      mercado.',
    images: [require('@/assets/img/idi.jpg'), require('@/assets/img/planeacion.jpeg')],
  },
  {
    body: () => import('../content/servicios/iaas.html'),
    path: '/iaas-infraestructura-como-servicio',
    title: 'IaaS (Infraestructura como Servicio)',
    keywords:
      'IaaS, Infraestructura como Servicio, Oracle, AWS EC2, Google Compute Engine, Azure Virtual Machines, Servidores en la Nube, Escalabilidad, Pago por Uso, Infraestructura Flexible, Cloud \
      Computing.',
    description:
      'Obtén control total sobre tu infraestructura en la nube. Ing. Obed Javier diseña y gestiona soluciones IaaS para ofrecerte la máxima flexibilidad, escalabilidad y control sobre tus recursos \
      de TI.',
    images: [require('@/assets/img/iaas-paas-saas.png')],
  },
  {
    body: () => import('../content/servicios/paas.html'),
    path: '/paas-plataforma-como-servicio',
    title: 'PaaS (Plataforma como Servicio)',
    keywords: 'PaaS, Plataforma como Servicio, Oracle, Google App Engine, AWS Elastic Beanstalk, Desarrollo Ágil, DevOps, Entornos de Desarrollo, Despliegue de Aplicaciones, Time-to-Market.',
    description:
      'Acelera el desarrollo y despliegue de tus aplicaciones. Ing. Obed Javier utiliza soluciones PaaS para que tus equipos de desarrollo se enfoquen en el código, no en la infraestructura \
      subyacente.',
    images: [require('@/assets/img/iaas-paas-saas.png')],
  },
  {
    body: () => import('../content/servicios/pmo.html'),
    path: '/project-management-gestion-de-proyectos',
    title: 'Project Management (Gestión de Proyectos)',
    keywords: 'Gestión de Proyectos, Project Management, Liderazgo de Proyectos, Metodologías Ágiles, Scrum, Kanban, Entrega de Proyectos, PMO, Proyectos de TI, Scrum Master.',
    description:
      'Asegura el éxito de tus proyectos tecnológicos con un liderazgo experto. Ing. Obed Javier gestiona tus iniciativas de principio a fin, garantizando entregas a tiempo, dentro del presupuesto \
      y alineadas con tus objetivos.',
    images: [require('@/assets/img/pmo.jpg'), require('@/assets/img/otros.jpg')],
  },
  {
    body: () => import('../content/servicios/saas.html'),
    path: '/saas-software-como-servicio',
    title: 'SaaS (Software como Servicio)',
    keywords: 'SaaS, Software como Servicio, Soluciones en la Nube, Implementación de SaaS, Integración de SaaS, Consultoría SaaS, Optimización de Costos, Productividad, Herramientas Colaborativas.',
    description:
      'Adopta las mejores herramientas del mercado sin la carga de la gestión. Ing. Obed Javier te asesora en la selección, implementación e integración de soluciones SaaS para potenciar tu \
      productividad.',
    images: [require('@/assets/img/iaas-paas-saas.png')],
  },
  {
    body: () => import('../content/servicios/sem.html'),
    path: '/sem-mercadotecnia-para-motores-de-busqueda',
    title: 'SEM (Mercadotecnia para Motores de Búsqueda)',
    keywords: 'SEM, Marketing en Buscadores, Google Ads, Publicidad de Pago por Clic (PPC), Campañas de Búsqueda, Remarketing, Optimización de Conversiones, ROAS, Estrategia de Puja.',
    description:
      'Obtén visibilidad y clientes de forma inmediata en los motores de búsqueda. Ing. Obed Javier crea y gestiona campañas de SEM (Google Ads) enfocadas en maximizar tu retorno de la inversión \
      publicitaria (ROAS).',
    images: [require('@/assets/img/SEM.jpg'), require('@/assets/img/SEM.gif')],
  },
  {
    body: () => import('../content/servicios/seo.html'),
    path: '/seo-optimizacion-para-motores-de-busqueda',
    title: 'SEO (Optimización para Motores de Búsqueda)',
    keywords: 'SEO, Optimización para Motores de Búsqueda, Posicionamiento Web, SEO On-Page, SEO Off-Page, SEO Técnico, Link Building, Investigación de Keywords, Auditoría SEO, Tráfico Orgánico.',
    description:
      'Atrae tráfico orgánico y sostenible a tu sitio web. Ing. Obed Javier implementa estrategias de SEO integrales para mejorar tu ranking en Google y convertirte en una autoridad en tu sector.',
    images: [require('@/assets/img/SEO.jpg')],
  },
  {
    body: () => import('../content/servicios/smo.html'),
    path: '/smo-optimizacion-para-redes-sociales',
    title: 'SMO (Optimización para Redes Sociales)',
    keywords: 'SMO, Optimización para Redes Sociales, Perfiles Sociales, Estrategia de Contenido, Engagement, Viralización, Social Sharing, Integración Web, Aumento de Seguidores.',
    description:
      'Convierte tus redes sociales en potentes canales de adquisición y difusión. Ing. Obed Javier optimiza tus perfiles y estrategia de contenido para aumentar el alcance, la interacción y el \
      tráfico a tu web.',
    images: [require('@/assets/img/SMO.jpeg')],
  },
  {
    body: () => import('../content/servicios/smm.html'),
    path: '/smm-mercadotecnia-en-redes-sociales',
    title: 'SMM (Mercadotecnia en Redes Sociales)',
    keywords:
      'SMM, Marketing en Redes Sociales, Social Media Marketing, Facebook Ads, Instagram Ads, LinkedIn Ads, Publicidad en Redes Sociales, Segmentación de Audiencia, Campañas Sociales, Generación de \
      Leads.',
    description:
      'Llega a tu audiencia ideal con precisión quirúrgica a través de la publicidad en redes sociales. Ing. Obed Javier diseña y gestiona campañas de SMM para aumentar tu visibilidad, generar leads \
      y potenciar tus ventas.',
    images: [require('@/assets/img/socialmedia.jpg')],
  },
  {
    body: () => import('../content/servicios/virtualizacion.html'),
    path: '/virtualizacion',
    title: 'Virtualización',
    keywords:
      'Virtualización, VMware, Hyper-V, Servidores Virtuales, Consolidación de Servidores, Reducción de Costos de TI, Alta Disponibilidad, Recuperación ante Desastres, Infraestructura Eficiente.',
    description:
      'Maximiza la eficiencia de tu hardware y reduce costos operativos. Ing. Obed Javier implementa soluciones de virtualización para consolidar servidores, mejorar la gestión y garantizar la \
      continuidad de tu negocio.',
    images: [require('@/assets/img/Virtualization.png')],
  },
  /*{
    body: () => import('../content/about.html'),
    path: '/sobre-mi',
    title: 'Sobre mí',
    keywords: 'ingeniero sistemas, consultor TI, experiencia tecnológica, desarrollo, consultoría',
    description: 'Ingeniero en Sistemas con +10 años de experiencia: soluciones eficientes, escalables y adaptadas a objetivos de negocio.',
    images: [require('@/assets/img/dudas.jpg')],
  },
  {
    body: () => import('../content/proyecto.html'),
    path: '/proyecto',
    title: 'Destacar Proyecto',
    keywords: 'posicionamiento proyecto, marketing digital, captación clientes, conversión',
    description: 'Estrategias para que tu proyecto destaque: atracción de clientes, optimización de conversión y mejoras de visibilidad online.',
    images: [require('@/assets/img/ti-project.jpg')],
  },
  {
    body: () => import('../content/otros.html'),
    path: '/otros',
    title: 'Otros Servicios',
    keywords: 'consultoría TI, redes, e-commerce, marketing digital, gestión proyectos, facturación electrónica',
    description: 'Consultoría tecnológica: redes, e-commerce, e-marketing, gestión de proyectos y facturación electrónica para optimizar procesos y ventas.',
    images: [require('@/assets/img/otros.jpg')],
  },
  {
    body: () => import('../content/project.html'),
    path: '/project',
    title: 'Gestón de Proyectos',
    keywords: 'cloud computing, SaaS, PaaS, IaaS, migración cloud, consultoría cloud',
    description: 'Consultoría cloud: migración, arquitectura y operaciones en nubes públicas y privadas para optimizar costes y escalabilidad.',
    images: [require('@/assets/img/saas.jpg')],
  },
  {
    body: () => import('../content/patita.html'),
    path: '/patita',
    title: 'Proyectos Patita',
    keywords: 'proyectos sociales, responsabilidad social, donaciones, causas animales',
    description: 'Proyectos con causa: parte de las ganancias se destinan a ayudar a organizaciones de rescate animal.',
    images: [require('@/assets/img/patita.jpg'), require('@/assets/img/happy-patita.jpg')],
  },*/
  {
    body: () => import('../content/terminos.html'),
    path: '/terminos',
    title: 'Términos de Servicio',
    keywords: 'términos servicio, legal, condiciones uso, políticas, privacidad',
    description: 'Términos y condiciones de uso del sitio y servicios; información legal sobre derechos, responsabilidades y privacidad.',
  },
  {
    body: () => import('../content/privacidad.html'),
    path: '/privacidad',
    title: 'Políticas de Privacidad',
    keywords: '',
    description: '',
  },
];

export default createStore({
  state: {
    pagesContent: $content,
    // cache opcional para evitar múltiples fetches
    pageBodies: {}, // { [path]: '<html...>' }
  },
  getters: {},
  mutations: {
    SET_PAGE_BODY(state, { path, html }) {
      state.pageBodies[path] = html;
    },
  },
  actions: {
    // fetchPageBody ahora soporta:
    //  - { page } donde page.body puede ser función (dynamic import) o string
    //  - { bodyPath } para fetch desde public (si lo usas)
    //  - path: clave de cache
    async fetchPageBody({ commit, state }, { bodyPath, path, page, force = false } = {}) {
      // 1) Si se pasó page y tiene body inline
      if (page) {
        // Si es función lazy (p. ej. () => import('...html'))
        if (typeof page.body === 'function') {
          // Si está en cache y no forzamos
          if (!force && path && state.pageBodies[path]) return state.pageBodies[path];
          try {
            const mod = await page.body(); // dynamic import
            const html = (mod && (mod.default || mod)) || '';
            if (path) commit('SET_PAGE_BODY', { path, html });
            return html;
          } catch (e) {
            console.error('Error importando body desde función:', e);
            return '';
          }
        }
        // Si ya es string inline
        if (typeof page.body === 'string') {
          return page.body;
        }
      }

      // 2) Si se pasó bodyPath (público), usar fetch
      if (!bodyPath) return '';
      if (!force && path && state.pageBodies[path]) return state.pageBodies[path];
      try {
        const res = await fetch(bodyPath, { cache: 'no-store' });
        if (!res.ok) throw new Error(`fetch ${bodyPath} ${res.status}`);
        const html = await res.text();
        if (path) commit('SET_PAGE_BODY', { path, html });
        return html;
      } catch (e) {
        console.error('Error cargando body desde', bodyPath, e);
        return '';
      }
    },
  },
  modules: {
    pages,
  },
});
